export interface PreAuthorizedDebitModeV1Response {
  preAuthorizedDebitMode: PreAuthorizedDebitMode;
}

export enum PreAuthorizedDebitMode {
  // Pre-authorized debit is required.
  Required = 'Required',
  // Pre-authorized debit is not required.
  NotRequired = 'NotRequired',
  // Pre-authorized debit is optional.
  Optional = 'Optional',
  // No pre-authorized debit feature is assigned.
  None = 'None',
  // Tenant has more than one pre-authorized debit feature assigned (invalid configuration).
  InvalidConfiguration = 'InvalidConfiguration',
}
